import { createSelector } from '@reduxjs/toolkit';
import { EVENT_GAME_TYPE_PROP_STAKE } from '@ogsnetwork/opp-api-lib';
import { customerSelector, openEventsSelector } from './index';
export const propBetOpenEventsSelector = createSelector(customerSelector, openEventsSelector, (customer, events) => events.filter((event) => event.gameType === EVENT_GAME_TYPE_PROP_STAKE));
